import jsPDF from 'jspdf';
import 'jspdf-autotable';
import speranzaLogo from '../../assets/logos/speranza_logo.png';

const loadImage = (url) => {
    return new Promise((resolve) => {
        if (!url) return resolve(null);
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = url;
    });
};

export const exportStandardPDF = async ({
    docTitle,
    tableColumn,
    tableRows,
    delegacaoLogoUrl,
    fileName
}) => {
    try {
        const doc = new jsPDF();
        const current_date = new Date().toLocaleDateString();
        
        // Draw header
        await applyPdfLayout(doc, docTitle, delegacaoLogoUrl);

        doc.autoTable({
            startY: 48,
            head: [tableColumn],
            body: tableRows,
            theme: 'grid',
            headStyles: { fillColor: [24, 144, 255] }
        });
        
        // Footer is drawn by applyPdfLayout automatically at the end of the document, 
        // but since we don't know the exact end of the table, we draw it manually here
        const finalY = doc.lastAutoTable.finalY || 48;
        addPdfFooter(doc, finalY + 10);

        doc.save(fileName);
    } catch (error) {
        console.error("Erro ao gerar PDF", error);
    }
};

export const applyPdfLayout = async (doc, docTitle, delegacaoLogoUrl) => {
    const current_date = new Date().toLocaleDateString();
    
    // Load logos
    const speranzaImg = await loadImage(speranzaLogo);
    const delegacaoImg = await loadImage(delegacaoLogoUrl);

    if (speranzaImg) {
        doc.addImage(speranzaImg, 'PNG', 14, 10, 40, 15);
    }
    if (delegacaoImg) {
        doc.addImage(delegacaoImg, 'PNG', 160, 10, 35, 20);
    }

    doc.setFontSize(10);
    doc.text(`Data: ${current_date}`, 14, 35);
    doc.setFontSize(12);
    doc.text(docTitle, 14, 42);
};

export const addPdfFooter = (doc, yPosition) => {
    doc.setFontSize(9);
    doc.setTextColor(100);
    const timestamp = new Date().toLocaleString();
    doc.text(`Documento processado por computador: ${timestamp}`, 14, yPosition);
};
